import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { Map } from 'immutable';
import * as modalActions from 'js/store/actions/modal';
import SearchCountry from '../index';
import * as userAuthActions from '../../../store/reducers/auth/user/actions';
import * as navActions from '../../../store/reducers/nav/header/actions';
import Countries from '../data/index';
var data = Countries().layers;
var actions = [modalActions, userAuthActions, navActions];

function mapDispatchToProps(dispatch) {
  var _Map;

  var creators = (_Map = Map()).merge.apply(_Map, actions).filter(function (value) {
    return typeof value === 'function';
  }).toObject();

  return {
    actions: bindActionCreators(creators, dispatch),
    dispatch: dispatch
  };
}

function mapStateToProps(state) {
  return {
    countries: data,
    user: state.user,
    isMobileWidth: state.device.isMobileWidth,
    windowWidth: state.device.windowWidth,
    isMobile: state.device.isMobileWidth
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(SearchCountry);